import { Divider } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from '../../../../../../../utils/propTypes';

const LayoutHeader = ({ template, supplier, phone, email }) => {
  const intl = useIntl();
  return (
    <div className="row">
      <div className="col-xs-12 col-md-4">
        <p
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          <strong>
            {intl.formatMessage({ id: 'layoutHeader.templateName' })}
          </strong>
          : {template}
        </p>
        <p
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          <strong>{intl.formatMessage({ id: 'layoutHeader.supplier' })}</strong>
          : {supplier}
        </p>
      </div>
      <div className="col-xs-12 col-md-4">
        <p
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          <strong>
            {intl.formatMessage({ id: 'layoutHeader.phone_number' })}
          </strong>
          : {phone}
        </p>
        <p
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          <strong>{intl.formatMessage({ id: 'layoutHeader.email' })}</strong>:{' '}
          {email}
        </p>
      </div>
      <Divider />
    </div>
  );
};

LayoutHeader.propTypes = {
  template: PropTypes.string,
  supplier: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
};

LayoutHeader.defaultProps = {
  template: '--',
  supplier: '--',
  phone: '--',
  email: '--',
};

export default LayoutHeader;
